
import React , { useState , useContext , useMemo  ,useRef , useEffect} from 'react';  

const useUserNotificationsSummary = ( authService ) => {

    const mounted = useRef(false);
    const userNotificationService = useRef(null);
    
    useEffect(()=>{

        if( !mounted.current ){

            // setup notificationService 
            mounted.current = true;
        }

        return ()=>{
            // destroyed // cleanup
        };
    }, []);


    return [{
        'pagedData' : { 
            'items' : [],
            'pagination' : {
                'numItemsTotal' : 1,
                'numPages' : 1,
                'currentPage' : 1,
                'numItemsCurrentPage' : 1 
            }
        }, 
        'accountManagerInvitesSummary' : {
            'totalInvitesPending' : 1 ,
            'totalInvitesNotSeen' : 1,
            'items' : [
                {
                    'accountLabel' : '' ,
                    'accountId' : '212u12h812' ,
                    'role' : 'admin'
                }
            ]
        },
        'newOrderSummary' : {}
    } , 1 ];
}

export default useUserNotificationsSummary;
